import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createBlock(_component_swiper, {
    modules: $setup.modules,
    autoHeight: true,
    spaceBetween: 30,
    speed: 500,
    breakpoints: $setup.breakpoints,
    slidesPerView: 4,
    navigation: { nextEl: '.js-news-next', prevEl: '.js-news-prev' }
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}